import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';

import { PresenceType } from '../../../Models/DTO/Booking.models';
import { requestUpdateBookingPresence } from '../../../store';
import PresenceStatusCellComponent from './PresenceStatusCell.component';
import { selectEventById } from '../../../store/events';
import { selectIsCheckInOpen } from '../../../store/bookings';
import { CellProps } from './CellProps';

export interface PresenceStatusCellProps extends CellProps {
  value: {
    presenceType: PresenceType;
    id: number;
    eventUUID: string;
  };
}

export const usePresenceStatusCell = (eventUUID: string) => {
  const dispatch = useDispatch();
  const updatePresence = bindActionCreators(requestUpdateBookingPresence, dispatch);
  const selectedEvent = useSelector(selectEventById(eventUUID));
  const checkInAvailable = useSelector(selectIsCheckInOpen(selectedEvent.id));

  return {
    updatePresence,
    checkInAvailable,
  };
};

const PresenceStatusCellContainer = ({ value, className }: PresenceStatusCellProps) => {
  const { updatePresence, checkInAvailable } = usePresenceStatusCell(value.eventUUID);

  const handlePresenceChanged = (presenceType: PresenceType) => {
    updatePresence({
      bookingId: value.id,
      presenceType,
    });
  };

  // Return nothing until the checkin has been openend
  // Might need improvement with the eventid on the table map
  if (!checkInAvailable) return null;

  return (
    <PresenceStatusCellComponent
      presence={value.presenceType}
      updatePresence={handlePresenceChanged}
      className={className}
    />
  );
};

export default PresenceStatusCellContainer;
